import { BaseEntity } from "yt-ng-framework";

export class Posao extends BaseEntity{
    constructor(){
        super()
    }

    Naziv: string=null;
    Opis: string=null;


    Deserialize(input:any){
        this.ID=input.ID;
        this.Naziv=input.Naziv;
        this.Opis=input.Opis;

        return this;
    }

    Serialize(input:Posao){
        return input;
    }
}